import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=4db56586&scoped=true&"
import script from "./WelcomeView.vue?vue&type=script&lang=js&"
export * from "./WelcomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db56586",
  null
  
)

export default component.exports